import { render, staticRenderFns } from "./createform.vue?vue&type=template&id=0d9f0e38&scoped=true"
import script from "./createform.vue?vue&type=script&lang=js"
export * from "./createform.vue?vue&type=script&lang=js"
import style0 from "./createform.vue?vue&type=style&index=0&id=0d9f0e38&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9f0e38",
  null
  
)

export default component.exports